import React from 'react';
import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import {
  Datagrid,
  DateField,
  ExportButton,
  Filter,
  List,
  Resource,
  SearchInput,
  ShowGuesser,
  TextField,
  TopToolbar,
} from 'react-admin';
import UserReferenceField from 'shared-fields/UserReferenceField';
import UserReferenceInput from 'shared-fields/UserReferenceInput';
import TextSnippetRoundedIcon from '@mui/icons-material/TextSnippetRounded';
import OrganizationReferenceInput from 'shared-fields/OrganizationReferenceInput';
import OrganizationReferenceField from 'shared-fields/OrganizationReferenceField';
import { ORG_ID } from 'config';
import { DetailsField } from './DetailsField';
import { RecordReferenceField } from './RecordReferenceField';
import { ActionField } from './ActionField';
import { CopyField } from 'shared-fields/CopyField';

function ActivitiesFilter(props) {
  return (
    <Filter {...props}>
      <SearchInput source="searchQuery" alwaysOn />
      <UserReferenceInput alwaysOn />
      {!ORG_ID && <OrganizationReferenceInput alwaysOn />}
    </Filter>
  );
}

export function ActivitiesListContent() {
  return (
    <Datagrid bulkActionButtons={false}>
      <CopyField source="id" label="ID" />
      <ActionField />
      <UserReferenceField label="Admin" />
      <RecordReferenceField />
      <DetailsField />
      {!ORG_ID && <OrganizationReferenceField />}
      <DateField source="createdAt" label="Created" showTime locales="fa-IR" />
      <DateField source="updatedAt" label="Updated" showTime locales="fa-IR" />
    </Datagrid>
  );
}
export function ActivitiesList() {
  const hasRole = useHasRole();
  return (
    <List
      sort={{ field: 'id', order: 'DESC' }}
      perPage={25}
      filters={<ActivitiesFilter />}
      actions={(
        <TopToolbar>
          {hasRole(Role.ORG_SUPER_ADMIN) && <ExportButton />}
        </TopToolbar>
      )}
    >
      <ActivitiesListContent />
    </List>
  );
}

export const renderActivitiesResource = (roles) => (
  <Resource
    options={{
      label: 'Activities',
    }}
    name="activities"
    list={ActivitiesList}
    show={ShowGuesser}
    icon={TextSnippetRoundedIcon}
  />
);
